* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  --font-family: var(--font-family-secondary);
}

.double-column-details {
  display: flex;
  flex-direction: column;
  padding: calc(var(--spacer) * 3) 0;

  .double-column-details-header {
    display: flex;
    align-items: center;
    margin-bottom: calc(var(--spacer) / 2);
    // i added this padding here so if component is inside gzContextMenuOverlay, gzContextMenuOverlay can have width: fit content
    padding: 0 calc(var(--spacer) * 3);

    ::slotted([slot='header-content-left']),
    ::slotted([slot='header-content-right']) {
      border-bottom: 1px solid var(--chart-101-pressed-dividers);
      padding-bottom: calc(var(--spacer) / 2);
      font-size: var(--body-size-xxlarge);
    }

    ::slotted([slot='header-content-left']) {
      flex-grow: 2;
      color: var(--main-titles-inputs-600);
    }
    ::slotted([slot='header-content-right']) {
      flex-grow: 1;
      text-align: right;
      color: var(--main-titles-inputs-600);
    }
  }

  .double-column-details-content {
    display: flex;
    flex-direction: column;
    // i added this padding here so if component is inside gzContextMenuOverlay, gzContextMenuOverlay can have width: fit content
    padding: 0 calc(var(--spacer) * 3);

    .item {
      display: flex;
      flex-direction: row;
      padding: calc(var(--spacer) / 4) 0;

      .item-label {
        flex: 1;
      }
      .item-value {
        flex: 0;
        display: flex;
        justify-content: end;
        min-width: 56px;
        padding-left: calc(var(--spacer) * 3);
        margin-left: auto;
        text-align: right;
      }
    }
  }
}
